var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.videoVisible)?_c('div',{staticClass:"video-box"},[_c('div',{staticClass:"content"},[_c('video',{staticClass:"video",attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.src}}),_vm._v(" 您当前使用的浏览器不支持HTML5视频。 ")]),_c('div',{staticClass:"close-btn",on:{"click":_vm.close}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }